import { useEffect, useState } from "react";
import { FoxCommonCardListWrapper } from "../../atom";
import {
  FoxNormalRechargeWrapper,
  MemberCard,
  Price,
} from "../fox-normal-recharge/atom";
import { useFoxTopUpStore } from "../../store";
import CheckIcon from "@/assets/icons/topup/check";
import { useGlobalStore } from "@/store/GlobalStore";
import { StripeList, StripeListDev } from "@/constant/StripeList";
import { isDev } from "project-config/utils/env";

export function FoxStripeRecharge() {
  const { setter: setFoxTopUpStore } = useFoxTopUpStore();
  const [checkCardPrice, setCheckCardPrice] = useState(0);
  const { currencySymbol } = useGlobalStore();
  const list = isDev() ? StripeListDev : StripeList;
  useEffect(() => {
    setCheckCardPrice(list[0].price);
    setFoxTopUpStore({
      amount: list[0].price,
      isCheckCard: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FoxNormalRechargeWrapper>
      <FoxCommonCardListWrapper>
        {list.map((item) => {
          return (
            <MemberCard
              key={item.price}
              className={item.price === checkCardPrice ? "active" : ""}
              onClick={() => {
                setCheckCardPrice(item.price);
                setFoxTopUpStore((state) => {
                  state.amount = item.price;
                  state.isCheckCard = true;
                  state.checkedRadioId = 0;
                });
              }}
            >
              <Price className={item.price === checkCardPrice ? "active" : ""}>
                <div>
                  <span className="unit">{currencySymbol}</span>
                  <span>{item.price}</span>
                </div>
                {item.price === checkCardPrice && <CheckIcon fill="#F3512B" />}
              </Price>
            </MemberCard>
          );
        })}
      </FoxCommonCardListWrapper>
    </FoxNormalRechargeWrapper>
  );
}
